export class RelativePriceFormatValueConverter {
    toView(numericValue, showSign, isSelectedElement = false) {
        // value 0 => ""
        // value: 52900 => "+529 €"
        // value: -52900 => "-529 €"
        var value = numericValue.toString();
        if (value == '0' ) {
            if (isSelectedElement) return "";
            return "+0 €";
        }
        var res = value.substr(0, value.length - 2);
        if (showSign != undefined && showSign && value.substr(0,1) != '-' ) {
            res = "+" + res;
        }
        res = res + " €";
        return res;
    }
}
